import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { SortField } from '~/utils/types/common';
import { DEFAULT_PAGE, ROWS_PER_PAGE } from '~/utils/constants/common';
import { handleGetCompanyRoles, handleGetCompanyRoleSelect } from './companyRoleThunk';
import { ICompanyRole } from '~/utils/interface/company-role';

export interface CompanyRoleState {
  companyRoles: Array<ICompanyRole>;
  roleId: string;
  filter: IFilter;
  currentPage: number;
  totalPages: number;
  needRefreshData: boolean;
  selectedIds: Array<string>;
  openAlertDelete: boolean;
  menuSelectedId: string | undefined;
  companyRoleSelects: Array<ICompanyRole>;
}

interface IFilter {
  page?: number;
  limit?: number;
  search?: string;
  searchFields?: Array<string>;
  sort?: Array<SortField>;
}

const initialState: CompanyRoleState = {
  companyRoles: [],
  roleId: '',
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  needRefreshData: false,
  filter: {
    page: 1,
    limit: ROWS_PER_PAGE,
    search: '',
    searchFields: [],
    sort: [],
  },
  selectedIds: [],
  openAlertDelete: false,
  menuSelectedId: undefined,
  companyRoleSelects: [],
};

const companyRoleSlice = createSlice({
  name: 'companyRole',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<IFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
      if (!state.openAlertDelete) {
        state.menuSelectedId = undefined;
      }
    },

    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(handleGetCompanyRoles.fulfilled, (state, action) => {
      state.companyRoles = [...action.payload.responses];
      state.currentPage = action.payload.pagination.page;
      state.totalPages = action.payload.pagination.totalPages;
      state.needRefreshData = false;
    });

    builder.addCase(handleGetCompanyRoleSelect.fulfilled, (state, action) => {
      state.companyRoleSelects = [...action.payload.responses];
      state.needRefreshData = false;
    });
  },
});

export const companyRoleActions = companyRoleSlice.actions;

const companyRoleReducer = companyRoleSlice.reducer;
export default companyRoleReducer;
